<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <h4 class="card-title">{{ title }}</h4>
              <p class="card-category">{{ description }}</p>
            </template>

            <div class="row">
              <!-- <div class="col-md-4">
                <div class="form-group">
                  <label for="finder">Búsqueda</label>
                  <div class="input-group">
                    <input type="text" v-model="finder" @keyup="loadElements" class="form-control custom-placeholder"
                      :placeholder="finderLabel" id="finder" />

                  </div>
                </div>
              </div> -->

              <!-- <div class="col-md-4">
                <label class="custom-placeholder">Filtrar por tipo</label>
                <multiselect v-model="filter_stocks" label="code" class="custom-rounded-multiselect text-capitalize"
                  :options="stockTmp" @select="loadElements" @remove="loadElements" selectLabel="Click/enter para elegir"
                  selectedLabel="Seleccionado" deselectLabel="Click/Enter para remover" :searchable="true"
                  :placeholder="filterLabel" placeholder-class="custom-placeholder"></multiselect>

              </div> -->

              <!-- <div class="col-md-4 d-flex align-items-end justify-content-end">
                <button type="button" data-toggle="tooltip" data-placement="top" title="Crear nuevo"
                  class="btn btn-fill float-right  btn-info" @click.prevent="goNew">
                  <span style="color: white">
                    <v-icon name="plus" class="mx-1" fill="white"></v-icon>
                    {{ buttonNewLabel }}
                  </span>
                </button>
              </div> -->
            </div>

            <div class="row mt-3">
              <div class="col-md-12 p-0">
                <l-table
                  class="table table-hover postlation_table text-xs"
                  style="width: 100%"
                  :columns="tableData.columns"
                  :data="Platforms"
                  :deleteStatus="deleteStatus"
                  :openUploadElement="openUploadElement"
                  :openModalPayment="openModalPayment"
                  :buttons="buttons"
                  :metaInfo="metaInfo"
                  :loadData="loadElements"
                >
                </l-table>

                <!-- MODAL UPLOAD IMAGE -->
                <div
                  class="modal fade"
                  :id="'modalPostulation'"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">
                          <strong>Requisitos</strong>
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click.prevent="closeUploadElement"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <form>
                          <div class="row">
                            <div class="col-md-6">
                              <p>{{ form_update.requires }}</p>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="filesUser && filesUser.length > 0"
                          >
                            <div class="col-md-12">
                              <h6><u>Tus archivos</u></h6>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              (form_update.id_type_status == 1 &&
                                filesUser &&
                                filesUser.length > 0) ||
                              (form_update.id_type_status == 2 &&
                                filesUser &&
                                filesUser.length > 0)
                            "
                            v-for="item in filesUser"
                          >
                            <div class="col-md-10 me-0">
                              <a :href="item.url_file" target="_blank">{{
                                item.name
                              }}</a>
                            </div>
                            <div class="col-md-2">
                              <button
                                type="submit"
                                class="btn btn-sm bg-gradient-fvf-switch"
                                style="
                                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
                                "
                                @click.prevent="deleteFile(item.id)"
                              >
                                <v-icon
                                  name="trash"
                                  fill="#CE0D0D"
                                  size="20px"
                                ></v-icon>
                              </button>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="
                              form_update.id_type_status == 1 ||
                              form_update.id_type_status == 2
                            "
                          >
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-12">
                                  <file-pond
                                    ref="filePond"
                                    name="image"
                                    v-model="form_save.url_file"
                                    allow-multiple="true"
                                    class="w-100 h-100"
                                    label-idle="Arrastre o seleccione los archivos"
                                  ></file-pond>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <div class="text-center">
                                <button
                                  v-if="
                                    form_update.id_type_status == 1 ||
                                    form_update.id_type_status == 2
                                  "
                                  type="submit"
                                  class="btn btn-sm btn-info btn-fill float-right"
                                  @click.prevent="uploadFiles"
                                >
                                  Subir
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MODAL PAYMENT REPORT -->
                <div
                  :class="
                    selectorOpen
                      ? 'modal fade show disable-scroll'
                      : 'modal fade show'
                  "
                  :id="'modalPayment'"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">
                          <strong>Nuevo pago</strong>
                        </h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click.prevent="closePaymentElement"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <form>
                          <div class="row">
                            <div class="col-md-12">
                              <h8
                                ><strong>Curso: </strong>
                                {{ form_update.platform.name }}</h8
                              >
                            </div>
                            <div class="col-md-12">
                              <h8
                                ><strong>Monto de inversión: </strong> ${{
                                  form_update.platform.amount
                                }}</h8
                              >
                            </div>
                            <div class="col-md-12">
                              <h8
                                ><strong>Tasa BCV: </strong> Bs.{{
                                  bcvRate.value
                                }}</h8
                              >
                            </div>
                            <div class="col-md-12">
                              <h8
                                ><strong>Total a pagar: </strong> Bs.{{
                                  totalPaymentAmount
                                }}</h8
                              >
                            </div>
                            <div class="col-md-12">
                              <hr size="8px" color="black" />
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-12">
                              <label>Banco de destino</label>
                              <multiselect
                                v-model="form_payment.id_company_bank"
                                label="name_bank"
                                class="custom-rounded-multiselect text-capitalize"
                                :options="companyBank"
                                selectLabel="Click/enter para elegir"
                                selectedLabel="Seleccionado"
                                deselectLabel="Click/Enter para remover"
                                :searchable="true"
                                :placeholder="'Seleccione el Banco de destino'"
                                placeholder-class="custom-placeholder"
                              ></multiselect>
                            </div>
                          </div>
                          <div
                            class="row mt-2"
                            v-if="form_payment.id_company_bank"
                          >
                            <div class="col-md-12">
                              <hr size="8px" color="black" />
                            </div>
                            <div class="col-md-12">
                              <p>
                                <strong>Datos para el pago:</strong>
                              </p>
                            </div>
                            <div class="col-md-12">
                              <p>
                                <strong>Teléfono :</strong>
                                {{ form_payment.id_company_bank.phone }}
                              </p>
                            </div>
                            <div class="col-md-12">
                              <p>
                                <strong>CI/RIF:</strong>
                                {{ form_payment.id_company_bank.dni }}
                              </p>
                            </div>
                          </div>
                          <div class="row" v-if="form_payment.id_company_bank">
                            <div class="col-md-12">
                              <hr size="8px" color="black" />
                            </div>
                            <div class="col-md-12">
                              <base-input
                                type="text"
                                label="Banco emisor"
                                placeholder="Indica el banco emisor"
                                v-model="form_payment.origin_bank"
                              >
                              </base-input>
                            </div>
                            <div class="col-md-12">
                              <label>Fecha de pago</label>
                              <date-picker
                                class="form-control align-content-center d-flex"
                                style="
                                  width: 100%;
                                  height: 50%;
                                  flex-wrap: wrap;
                                "
                                v-model="form_payment.date"
                                :format="'DD/MM/YYYY'"
                                placeholder="Selecciona una fecha"
                                popupPlacement="top"
                                @open="handleOpenChange"
                                @close="handleCloseChange"
                                :disabled-date="disableFutureDates"
                              ></date-picker>
                            </div>
                            <div class="col-md-12">
                              <base-input
                                type="number"
                                label="Teléfono"
                                placeholder="Indica el teléfono del banco emisor"
                                v-model="form_payment.phone"
                              >
                              </base-input>
                            </div>
                            <div class="col-md-12">
                              <base-input
                                type="text"
                                label="Monto pagado"
                                placeholder="Indica el monto pagado"
                                v-model="amountWithPrefix"
                              >
                              </base-input>
                            </div>

                            <div class="col-md-12">
                              <base-input
                                type="text"
                                label="Referencia"
                                placeholder="Indica la referencia del pago"
                                v-model="form_payment.reference"
                              >
                              </base-input>
                            </div>
                          </div>
                          <div class="row" v-if="form_payment.id_company_bank">
                            <div class="col-md-12">
                              <label>Captura del pago</label>
                              <file-pond
                                ref="filePondPayment"
                                name="capture"
                                v-model="form_payment.url_image"
                                allow-multiple="true"
                                class="w-100 h-100"
                                label-idle="Arrastre o seleccione la captura del pago"
                              ></file-pond>
                            </div>
                          </div>
                          <div class="row mt-2">
                            <div class="col-md-12">
                              <div class="text-center">
                                <button
                                  v-if="form_payment.id_company_bank"
                                  type="submit"
                                  class="btn btn-sm btn-info btn-fill float-right"
                                  @click.prevent="savePayment"
                                >
                                  Guardar
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function clearAccents(cadena) {
  let chars = {
    á: "a",
    é: "e",
    í: "i",
    ó: "o",
    ú: "u",
    à: "a",
    è: "e",
    ì: "i",
    ò: "o",
    ù: "u",
    ñ: "n",
    Á: "A",
    É: "E",
    Í: "I",
    Ó: "O",
    Ú: "U",
    À: "A",
    È: "E",
    Ì: "I",
    Ò: "O",
    Ù: "U",
    Ñ: "N",
  };
  let expr = /[áàéèíìóòúùñ]/gi;
  let res = cadena.replace(expr, function (e) {
    return chars[e];
  });
  return res;
}

import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import LTable from "src/components/Table.vue";
import Card from "src/components/Cards/Card.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Cookies from "js-cookie";
import moment, { max } from "moment";

export default {
  components: {
    LTable,
    Card,
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      //LABELS
      title: "Mis postulaciones",
      description:
        "Podrás gestionar tus postulaciones registradas en el sistema",
      buttonNewLabel: "Agregar nuevo usuario",
      buttonNewUrl: "UserIDNew",
      buttonEditUrl: "UserIDEdit",
      finderLabel: "Buscar",
      filterLabel: "Seleccione",
      listVisible: false,
      selectorOpen: false,
      //FILTERS
      filter_stocks: "",
      //VARIABLE
      finder: "",
      metaInfo: {},
      isBusy: false,
      //MODAL
      modalActiveUpdate: false,
      idTmp: 0,
      filesUser: [],
      bcvRate: {},
      companyBank: [],
      totalPaymentAmount: 0,
      amountWithDecimals: 0,

      id_user: Cookies.get("id"),

      form_payment: {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
      },

      form_save: {
        id_user_platform: "",
        name: "",
        url_file: "",
      },

      form_update: {
        id: 0,
        name: "",
        url: "",
        url_banner: "",
        url_image: "",
        description: "",
        autoapproved: "",
        platform: {
          name: "",
          amount: 0,
        },
        requires: "",
        id_type_status: "",
        id_type_status_payment: "",
      },

      data: [
        {
          profile_image: "../img/faces/face-0.jpg",
        },
        // ... otros objetos de datos ...
      ],
      //TABLE DATA
      tableData: {
        columns: [
          {
            name: "",
            key: "platform.url_image",
            type: "image",
          },
          {
            name: "Postulación",
            key: "platform.name",
          },
          {
            name: "Estado",
            key: "type_status.name",
          },
          {
            name: "Última actualización",
            key: "updated_at",
          },
          {
            name: "Acciones",
            key: "actions",
          },
        ],
        data: [],
      },
      //DATA Variables
      Platforms: [],
      stockTmp: [],
      //TABLE Buttons
      buttons: [
        {
          icon: "eye",
          icon_negative: "eye",
          type_button: "btn-info",
          tooltip: "Ver postulación",
          url: "",
          type_action: "go_method",
          action: "openUploadElement",
          fill_icon: "#FFC700",
        },
        {
          icon: "money-bill-wave",
          icon_negative: "check-square",
          type_button: "btn-danger",
          tooltip: "Reportar pago",
          url: "",
          type_action: "go_method",
          action: "openModalPayment",
          fill_icon: "#003068",
        },
        {
          icon: "trash",
          icon_negative: "trash",
          type_button: "btn-danger",
          tooltip: "Eliminar postulación",
          url: "",
          type_action: "go_method",
          action: "deleteStatus",
          fill_icon: "#CE0D0D",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    rows() {
      return this.PlatformsTmp.length;
    },
    amountWithPrefix: {
      get() {
        return `Bs. ${(this.form_payment.amount / 100).toLocaleString("es-VE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      },
      set(newValue) {
        const value = newValue.replace(/[^0-9]/g, ""); // Remove all non-numeric characters
        this.form_payment.amount = value;
        this.amountWithDecimals = parseFloat(value / 100).toFixed(2);
        console.log(this.amountWithDecimals);
      },
    },
  },
  mounted() {
    this.loadElements();
    this.loadBcvRate();
    this.loadCompanyBank();
  },
  updated() {
    // console.log(this.user);
  },
  methods: {
    ...mapActions([
      "getData",
      "getDataLite",
      "changeStatusData",
      "updateData",
      "createData",
    ]),

    savePayment() {
      if (this.form_payment.id_company_bank == "") {
        Swal.fire({
          title: "Seleccione un banco",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.origin_bank == "") {
        Swal.fire({
          title: "Ingrese el banco emisor",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.date == "") {
        Swal.fire({
          title: "Seleccione la fecha del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.phone == "") {
        Swal.fire({
          title: "Ingrese el teléfono del banco emisor",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.amount == 0) {
        Swal.fire({
          title: "Ingrese el monto pagado",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else if (this.form_payment.reference == "") {
        Swal.fire({
          title: "Ingrese la referencia del pago",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        return;
      } else {
        Swal.fire({
          title: "¿Estás seguro de reportar este pago?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Sí, reportar",
        }).then((result) => {
          if (result.value) {
            let data_form;
            data_form = new FormData();
            data_form.append("id_user", this.id_user);
            data_form.append("id_user_platform", this.form_update.id);
            data_form.append(
              "id_company_bank",
              this.form_payment.id_company_bank.id
            );
            data_form.append("id_bcv_rate", this.bcvRate.id);
            data_form.append("reference", this.form_payment.reference);
            data_form.append("origin_bank", this.form_payment.origin_bank);
            data_form.append("amount", this.amountWithDecimals);
            data_form.append(
              "date",
              new Date(this.form_payment.date).toISOString().slice(0, 10)
            );
            data_form.append("phone", this.form_payment.phone);
            const filePondInstance = this.$refs.filePondPayment.getFiles();
            if (filePondInstance && filePondInstance.length > 0) {
              const file = filePondInstance[0].file;
              data_form.append("url_image", file);
            }
            let form = {
              url: "user/payment_report/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.closePaymentElement();
                  Swal.fire({
                    title: "Pago registrado correctamente",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                  this.loadElements();
                }
              })
              .catch((error) => {
                console.log(error);
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
    },

    handleOpenChange() {
      console.log("OPEN DATE SELECTOR");
      this.selectorOpen = true;
    },

    handleCloseChange() {
      console.log("CLOSE DATE SELECTOR");
      this.selectorOpen = false;
    },

    disableFutureDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    showList() {
      this.listVisible = true;
    },

    goNew() {
      this.$router.push({ name: this.buttonNewUrl });
    },

    openUploadElement(data) {
      if (data.id_type_status == 3 && data.id_type_status_payment == 3) {
        Swal.fire({
          title: "Postulación aprobada",
          text: "Ya puedes acceder a la curso",
          icon: "success",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });

        this.$router.push({ path: "platform/" + data.id_platform });
      } else if (
        data.id_type_status == 3 &&
        (data.id_type_status_payment == 1 || data.id_type_status_payment == 0)
      ) {
        Swal.fire({
          title: "Postulación aprobada",
          text: "Ya puedes realizar el pago para acceder a la curso",
          icon: "success",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        this.$router.push({ path: "platform/" + data.id_platform });
      } else if (data.id_type_status == 3 && data.id_type_status_payment == 2) {
        Swal.fire({
          title: "Hubo un problema con tu pago",
          text: "Parece que tu pago fue rechazado, por favor, cree un nuevo reporte de pago y chequee que los datos son correctos para acceder a la curso",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        // this.$router.push({ path: "platform/" + data.id_platform });
      } else if (data.id_type_status == 3 && data.id_type_status_payment == 4) {
        Swal.fire({
          title: "Hubo un problema con tu pago",
          text: "Parece que tu pago estaba incompleto, por favor, pague el diferencial para acceder a la curso",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
        // this.$router.push({ path: "platform/" + data.id_platform });
      } else {
        this.loadUserFiles(data);
        this.form_update = data;
        this.idTmp = data.id;
        console.log("OPEN UPLOAD MODAL");
        setTimeout(() => {
          $("#modalPostulation").modal("toggle");
        }, 100); // tiempo en milisegundos

        this.modalActiveUpdate = true;
      }
    },

    closeUploadElement() {
      console.log("CLOSING UPLOAD MODAL");
      $("#modalPostulation").modal("toggle");
      this.modalActiveUpdate = false;
    },

    openModalPayment(data) {
      this.form_update = data;
      console.log(this.form_update);
      this.form_update.platform.amount = parseFloat(
        this.form_update.platform.amount
      ).toFixed(2);
      this.form_update.platform.amount =
        this.form_update.platform.amount.toLocaleString("es-VE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      this.bcvRate.value = parseFloat(this.bcvRate.value).toFixed(2);
      this.bcvRate.value = this.bcvRate.value.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      this.totalPaymentAmount = parseFloat(
        this.form_update.platform.amount * this.bcvRate.value
      ).toFixed(2);
      this.totalPaymentAmount = this.totalPaymentAmount.toLocaleString("es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      this.idTmp = data.id;
      console.log("OPEN PAYMENT MODAL");
      setTimeout(() => {
        $("#modalPayment").modal("toggle");
      }, 100); // tiempo en milisegundos
      this.modalActiveUpdate = true;
    },

    closePaymentElement() {
      console.log("CLOSING PAYMENT MODAL");
      $("#modalPayment").modal("toggle");
      this.form_payment = {
        id_company_bank: "",
        id_bcv_rate: "",
        reference: "",
        origin_bank: "",
        amount: 0,
        date: "",
        url_image: "",
      };
      this.modalActiveUpdate = false;
    },

    loadUserFiles(data) {
      if (data.id_type_status != 3) {
        let data_params = {
          url: "user_file_platform/all",
          params: {
            active: 1,
            id_user_platform: data.id,
            order_by: "id",
            order_key: "asc",
          },
        };

        this.getData(data_params)

          .then((response) => {
            if (response.code == 200) {
              this.filesUser = response.data;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    loadBcvRate() {
      let data_params = {
        url: "bcv_rate/all",
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.bcvRate = response.data[0];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCompanyBank() {
      let data_params = {
        url: "user/company_bank/all",
        params: {
          active: 1,
          order_by: "id",
          order_key: "asc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          if (response.code == 200) {
            this.companyBank = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteFile(id) {
      Swal.fire({
        title: "¿Estás seguro de eliminar este archivo?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#048224ff",
        cancelButtonColor: "#abb2ba",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar",
      }).then((result) => {
        if (result.value) {
          let data_form;
          data_form = {
            active: 2,
          };
          let form = {
            url: "user_file_platform/update",
            id: id,
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserFiles(this.form_update);
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
            });
        }
      });
    },

    loadElements() {
      let form = {
        url: "user/user_platform/all",
        params: {
          active: 1,
          page: 1,
          limit: 10,
          order_key: "updated_at",
          order_value: "desc",
          // id_user: Cookies.get("id"),
        },
      };

      if (this.metaInfo.current_page > 1) {
        form.params.page = this.metaInfo.current_page;
      }

      if (this.finder != "") {
        console.log("Searching:" + this.finder);
        form.params.query = this.finder;
        form.params.page = 1;
      }
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          response.data.data.forEach((element) => {
            element.updated_at = moment(element.updated_at)
              .subtract(4, "hours")
              .format("DD/MM/YYYY hh:mm A");
          });
          if (response.code === 200) {
            this.Platforms = response.data.data;
            this.metaInfo = response.data.meta;
            this.PlatformsTmp = this.Platforms;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    uploadFiles() {
      const filePondInstance = this.$refs.filePond.getFiles();
      if (filePondInstance && filePondInstance.length > 0) {
        Swal.fire({
          title: "Subiendo archivos...",
          icon: "info",
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        const promises = [];
        for (let i = 0; i < filePondInstance.length; i++) {
          let data_form;
          data_form = new FormData();
          const file = filePondInstance[i].file;
          const fileName = file.name;
          data_form.append("url_file", file);
          data_form.append("name", fileName);
          data_form.append("id_user_platform", this.form_update.id);
          let form = {
            url: "user_file_platform/save",
            data: data_form,
          };
          promises.push(this.createData(form));
        }

        Promise.all(promises)
          .then((responses) => {
            // Handle success
            this.deleting = false;
            this.closeUploadElement();
            this.loadUserFiles(this.form_update);
          })
          .catch((error) => {
            console.log(error);
            alert("Ocurrió un error, intente más tarde");
          })
          .finally(() => {
            Swal.close();
            Swal.fire({
              title: "Postulación actualizada correctamente",
              text: "Ahora debes esperar a que respondan tu solicitud",
              icon: "success",
              showConfirmButton: true,
              showLoaderOnConfirm: true,
            });
          });
      }else{
        Swal.fire({
          title: "No hay archivos para subir",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
      }
      this.$refs.filePond.removeFiles();
    },
    deleteStatus(data) {
      let title = "Eiminar postulación";

      let text = "¿Estás seguro de eliminar su postulación?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#B49B57",
        cancelButtonColor: "#9F9F9F",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let data_form = new FormData();
          data_form.append("active", 2);
          let form = {
            id: data.id,
            url: "user/user_platform/update",
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadElements();
                // data.active = active;
                Swal.fire({
                  title: "La postulación fue eliminada",
                  icon: "success",
                });
                this.loadElements();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.disable-scroll {
  overflow: visible;
}
</style>
<style>
.postlation_table {
  overflow: hidden;
  /* Agregar la propiedad overflow: hidden al elemento padre */
}
.postlation_table td:first-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}
.postlation_table td:nth-child(2) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 300px;
  width: 300px;
}
.postlation_table td:nth-child(3) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 120px;
  width: 120px;
}
.postlation_table td:nth-child(4) {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 300px;
  width: 300px;
}

.postlation_table td:last-child {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  justify-content: center;
  max-width: 200px;
  width: 200px;
}

.button-search {
  height: 100%;
  margin-left: 5px;
}

.my-table th:last-child {
  width: 35%;
}

.table-container {
  width: auto;
  max-width: 3000px;
  /* ajusta el valor al ancho máximo que desees */
  overflow-x: auto;
  align-items: center;
  text-align: center;
}

.l-table {
  width: 100%;
  table-layout: fixed;
}

.l-table td,
.l-table th {
  white-space: nowrap;
}

.my-button {
  margin-left: 10px;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border: 1px solid black;
  padding: 10px;
}

.custom-rounded-multiselect .multiselect__tags {
  border-radius: 2rem;
}

.custom-rounded-multiselect .multiselect__tags .multiselect__tag {
  border-radius: 2rem;
}

.custom-placeholder::placeholder {
  font-size: 14px;
  color: #cfcfca;
  display: inline-block;
  font-weight: 600;
}
</style>
